var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_11453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14.375C17.75 14.375 20 12.125 20 9.375C20 6.625 17.75 4.375 15 4.375C12.25 4.375 9.99998 6.625 9.99998 9.375C9.99998 12.125 12.25 14.375 15 14.375ZM28.625 15L29.625 14C30.125 13.5 30.125 12.75 29.625 12.25C29.125 11.75 28.375 11.75 27.875 12.25L26.875 13.25L25.875 12.25C25.375 11.75 24.625 11.75 24.125 12.25C23.625 12.75 23.625 13.5 24.125 14L25.125 15L24.125 16C23.625 16.5 23.625 17.25 24.125 17.75C24.625 18.25 25.375 18.25 25.875 17.75L26.875 16.75L27.875 17.75C28.375 18.25 29.125 18.25 29.625 17.75C30.125 17.25 30.125 16.5 29.625 16L28.625 15ZM15 16.25C10.375 16.25 6.37498 19.625 5.74998 24.25C5.62498 24.875 6.12498 25.625 6.87498 25.625H6.99998H23C23.75 25.625 24.25 25.125 24.25 24.375V24.25C23.625 19.625 19.625 16.25 15 16.25Z",
    fill: "#38369C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_11453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.62f94f6b2ed3964ed5057ee99fd0eaa2.svg";
export { ForwardRef as ReactComponent };